import { useState } from 'react';
import { Button, Collapse } from 'reactstrap';
import { getDiff } from '../../../utils/date';
import { AgentThinkingContainer } from './AgentThinkingContainer';
import { AgentThinking } from '../types';

interface CollapsibleContainerProps {
  dataArray: AgentThinking[];
  isThinking: boolean;
  togglerId: string;
  endTimestamp?: string;
}

export const CollapsibleContainer = (props: CollapsibleContainerProps) => {
  const { dataArray, isThinking, togglerId, endTimestamp } = props;

  const startTimestamp = dataArray[0].timestamp;

  const [isSetOpen, setIsOpen] = useState(isThinking);
  const isOpen = isSetOpen || isThinking;
  const thinkingTime = isThinking ? 0 : getDiff(endTimestamp ?? '', startTimestamp, 'second');

  return (
    <div style={{ animation: 'fadeIn 0.5s ease-in-out' }} className='mb-2'>
      {isThinking ?
      null :
        <div className='d-flex w-100'>
          <div style={{ width: '32px', minWidth: '32px' }} className='me-3' />
          <div className='flex-grow-1 text-right'>
            <Button color='link-secondary' className='p-0 text-ThemeAccentDark' id={togglerId} onClick={() => setIsOpen(!isOpen)}>
              {isOpen ? 'hide thinking' : thinkingTime >= 0 ? `thought for ${thinkingTime} seconds...` : 'show thinking'}
              &nbsp;<span className='text-decoration-underline'>(view)</span>
            </Button>
          </div>
          <div style={{ width: '32px', minWidth: '32px' }} className='ms-3' />
        </div>
      }
      <Collapse toggler={`#${togglerId}`} isOpen={isOpen}>
        {dataArray.map((data, i) => <AgentThinkingContainer key={i} data={data} isThinking={isThinking && i === dataArray.length - 1} endTimestamp={dataArray[i + 1]?.timestamp ?? endTimestamp} />)}
      </Collapse>
    </div>
  );
};
